import { css } from 'linaria';

export const constructionHousesProjectsGrid = css`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
  column-gap: 24px;
  row-gap: 32px;

  @media (--only-tablet) {
    grid-template-columns: repeat(3, 210px);
    column-gap: 16px;
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 100%);
    column-gap: 0;
    row-gap: 16px;
  }

  && a {
    border-radius: var(--rounding-l);
  }
`;

export const constructionHousesProjectImage = css`
  height: 262px;

  @media (--only-desktop) {
    height: 200px;
  }

  @media (--only-tablet) {
    height: 156px;
  }

  @media (--only-mobile) {
    height: 236px;
  }
`;

export const constructionHousesProjectContent = css`
  padding: 24px;

  @media (--only-tablet) {
    padding: 24px 16px;
  }

  @media (--only-mobile) {
    padding: 16px;
  }
`;

export const constructionHousesProjectName = css`
  @media (--from-desktop) {
    width: 222px;
  }
`;

export const constructionHousesProjectsMoreBtnWrapper = css`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 32px;
`;
